export default __webpack_public_path__ + "static/media/Home-Feat-03.f1261392.jpg";